<!--
 * @Author: cgh
 * @Date: 2022-08-01 10:53:11
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:02:24
 * @Description: 评估项目管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        评估项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog({ type:'add'})"
        />
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="设备名称"
                prop="sbmc"
              >
                <el-input
                  v-model.trim="filterParams.sbmc"
                  class="c-form__input"
                  placeholder="设备名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="设备编号"
                prop="sbbh"
              >
                <el-input
                  v-model.trim="filterParams.sbbh"
                  class="c-form__input"
                  placeholder="设备编号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="启用状态"
                prop="sfqy"
              >
                <el-radio-group v-model="filterParams.sfqy">
                  <el-radio label="">
                    全部
                  </el-radio>
                  <el-radio label="Y">
                    启用
                  </el-radio>
                  <el-radio label="N">
                    停用
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="pgyqTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #sbmc="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog({id: scope.row.id,type: 'details'})"
              >
                {{ scope.row.sbmc }}
              </el-link>
            </template>
            <template
              #yxq="scope"
            >
              {{ scope.row.yxq | date("yyyy-MM-dd") }}
            </template>

            <template
              #sfqy="scope"
            >
              <div
                :class="{
                  'u-text-danger': scope.row.sfqy === 'N',
                  'u-text-success': scope.row.sfqy === 'Y'
                }"
              >
                {{ scope.row.sfqy === 'Y'?'已启用':'已停用' }}
              </div>
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="180"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.sfqy ==='N' "
                  btn-text="启用"
                  :auth-type="true"
                  type="success"
                  plain
                  @click="handleZt(scope.row, 'Y')"
                />
                <k-button
                  v-else
                  btn-text="停用"
                  :auth-type="true"
                  plain
                  type="danger"
                  @click="handleZt(scope.row, 'N')"
                />
                <k-button
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleDialog({id: scope.row.id,type: 'edit'})"
                />
                <k-button
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  plain
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 添加/修改 -->
    <addOrUpdate-dialog
      v-if="showDialogName === 'edit' || showDialogName === 'add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
    <details-dialog
      v-if="showDialogName==='details'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { pgyqManageService } from './pgyq.service.js';
export default {
  name: 'Pgyq',
  components: {
    addOrUpdateDialog: () => import('./addOrUpdateDialog'),
    detailsDialog: () => import('./detailsDialog')
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        sbmc: null, // 设备名称
        sbbh: null, // 设备编号
        sfqy: '' // 启用状态
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      // filterParamsRules: {
      //   zxsjQZ: [this.$HMValidator.dateRange('开始时间')]
      // },
      /* 表单校验规则 End */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'sbmc', slotName: 'sbmc', label: '设备名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'sbbh', label: '设备编号', align: 'left', minWidth: '150', type: 'text' },
        { key: 'jyzjbh', label: '检定/校准证件编号', align: 'left', minWidth: '130', type: 'text' },
        { key: 'yxq', slotName: 'yxq', label: '有效期', align: 'center', minWidth: '130', type: 'text' },
        { key: 'sfqy', slotName: 'sfqy', label: '是否启用', align: 'left', minWidth: '50', type: 'text' }
      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      // [this.trueFilterParams.zxsjq, this.trueFilterParams.zxsjz] = this.trueFilterParams.zxsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      pgyqManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },

    /**
       * @description: 跳转到查看
       * @author: cgh
       */
    handleDialog (_params) {
      this.showDialogName = _params.type;
      this.dialogParams = _params;
    },
    /**
     * 启用/停用
     */
    handleZt (_row, _zt) {
      console.log(_row);
      if (_zt === 'Y') {
        _row.sfqy = 'Y';
        _zt = '启动';
      } else {
        _row.sfqy = 'N';
        _zt = '停用';
      }
      console.log(_row);
      this.updateSave(_row, _zt);
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave (_row, _zt) {
      this.loading = true;
      pgyqManageService.update(_row.id, _row)
        .then(rsp => {
          this.$alert(_zt + '成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
        })
        .catch(err => {
          console.error(_zt + '错误！', err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此评估仪器数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgyqManageService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      pgyqManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
